<template>
  <div class="appContent">

    <transition name="fade">
      <ModalOrder @removeOrder="removeOrder" @sendOrder="sendOrder" @closeModal="closeModalOrder"
        :orderData="this.selectedOrder" v-if="this.modalAddOrderOpen">
      </ModalOrder>
    </transition>

    <GlobalAlerts></GlobalAlerts>

    <MainMenu v-if="this.user"></MainMenu>

    <router-view v-slot="{ Component }">
      <component v-if="entryWasChecked" :is="Component" ref="activeComponent"></component>
    </router-view>

    <transition name="fade">
      <div class="backgoundShapes" :class="{ 'backgoundShapesLoading': loading }">
        <!-- <div class="backgoundShapesShape" :style="shape1Style"></div> -->
        <div class="backgoundShapesLoadingText" v-if="loading">
          Загрузка
        </div>
        <!-- <div class="backgoundShapesShape" :style="shape2Style"></div> -->
      </div>
    </transition>

  </div>
</template>
<script>
import MainMenu from "@/components/MainMenu.vue";
import GlobalAlerts from "@/components/GlobalAlerts.vue";
import ModalOrder from "@/components/Modals/ModalOrder.vue";

export default {
  components: {
    MainMenu,
    GlobalAlerts,
    ModalOrder
  },
  data() {
    return {
      entryWasChecked: false,

      intervalShapesReset: null,
      intervalShapes: null,
      shape1Style: { position: 'absolute', left: '30%', top: '20%' },
      shape2Style: { position: 'absolute', right: '30%', bottom: '20%' },
      originalPosition1: { left: '30%', top: '20%' },
      originalPosition2: { right: '30%', bottom: '20%' },
    }
  },
  async mounted() {


    await this.getSettings();
    await this.checkEntry();

  },
  computed: {
  },
  methods: {
    sendOrder(oOrder) {
      this.$refs.activeComponent.sendOrder(oOrder);
    },
    closeModalOrder() {
      this.setModalAddOrderOpen(false);
      this.setSelectedOrder(null);
    },
    removeOrder(order_id) {
      this.$refs.activeComponent.removeOrder(order_id);
    },
    resetPositionShapes() {
      this.shape1Style = { ...this.originalPosition1, transition: 'all 1s ease-in-out' };
      this.shape2Style = { ...this.originalPosition2, transition: 'all 1s ease-in-out' };
    },
    getRandomPosition(shape) {
      const randomX = Math.floor(Math.random() * window.innerWidth);
      const randomY = Math.floor(Math.random() * window.innerHeight);
      if (shape == 1) {
        return {
          left: `${randomX}px`,
          top: `${randomY}px`,
        };
      }
      if (shape == 2) {
        return {
          right: `${randomX}px`,
          bottom: `${randomY}px`,
        };
      }
    },

    async getSettings() {
      this.setLoading(true);
      const result = await this.requestData({
        action: "get-settings",
      });

      console.log(`v${localStorage.version}`)

      if (!localStorage.version) {
        localStorage.version = result.version;
        window.location.reload();
      } else if (localStorage.version != result.version) {
        localStorage.version = result.version;
        window.location.reload();
      }

      this.setSettings(result);
    },
    async checkEntry() {

      if (!localStorage || !localStorage.entry_key || localStorage.entry_key == 'undefined') {
        this.$router.push("/login");
        this.setLoading(false);
        this.entryWasChecked = true;
        return false;
      }

      this.setLoading(true);
      const result = await this.requestData({
        action: "checkEntry",
        entry_key: localStorage.entry_key,
      });

      if (result) {
        this.setUser(result);
        this.$router.push("/orders");
      } else {
        this.$router.push("/login");
        this.setLoading(false);
        this.entryWasChecked = true;
        return false;
      }

      this.entryWasChecked = true;

      this.setLoading(false);

    },
  }
}
</script>
<style>
:root {
  --background: #e0e0e0;
  --container: #d7d7d7;
  --block-on-container: #efefef;
  --text-container: #121212;
  --btn-container: #efefef;
  --positive: #00ff0d;
  --negative: #fc4444;

  --block-content: white;
}

body {
  background-color: var(--background);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Segoe UI', Segoe, Tahoma, Geneva, sans-serif;
}


.appContent {
  padding: 10px;
  height: 100vh;
}


.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;

}

.fade-leave-active {
  position: absolute;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

select {
  width: auto;
  padding: 5px;
  border-radius: 5px;
  text-align: center;
  font-size: 19px;
  font-weight: bold;
}

.flex-row-wrap {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.flex-column {
  display: flex;
  gap: 10px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}


.space-between {
  justify-content: space-between;
}

.formElemRow {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
}

.formElemRow span {
  font-weight: bold;
}

.formElemRow select,
.formElemRow textarea,
.formElemRow input {
  margin: 0 !important;
  width: 100%;
  text-align: start !important;
  resize: vertical;
  font-size: 18px !important;
  font-weight: 400 !important;
}

.headerElem {
  margin-bottom: 20px;
}

.checkbox-size input {
  width: 30px;
  height: 30px;
}

.backgoundShapes {
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  z-index: -1;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.backgoundShapes .backgoundShapesShape {
  height: 200px;
  width: 200px;
  position: absolute;
  border-radius: 50%;
  transition: all 10s;
}

.backgoundShapesLoading {
  z-index: 99999999;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(3px);
  transition: all .3s;
}

.backgoundShapesShape:first-child {
  background: linear-gradient(#1845ad,
      #23a2f6);
  left: 30%;
  top: 20%;
}

.backgoundShapesShape:last-child {
  background: linear-gradient(to right,
      #ff512f,
      #f09819);
  right: 30%;
  bottom: 20%;
}

.backgoundShapesLoadingText {
  padding: 10px 20px;
  border-radius: 10px;
  background: #ffffffc7;
  backdrop-filter: blur(2px);
}



.mainButton {
  transition: all .3s;
  cursor: pointer;
}

.mainButton:hover {
  opacity: .5;
}


.blockContent {
  background-color: var(--block-content);
  margin: 10px 0;
  padding: 10px;
  border-radius: 10px;
}














.confirmDelete {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: #646464e6;
  backdrop-filter: blur(2px);
  z-index: 3;
}

.confirmDeleteBtn button:nth-of-type(1) {
  opacity: .4;
}

.confirmDeleteBtn button {
  transition: all .3s;
}

.confirmDeleteBtn {
  display: flex;
  gap: 20px;
  flex-direction: row;
  justify-content: center;
  margin-top: 20px;
}

.confirmDeleteBtn button:hover {
  opacity: 1;
}


.error {
  color: red !important;
  width: 100%;
  font-weight: bold;
  text-align: center;
}

button {
  padding: 10px;
  width: 150px;
  border: none;
  background: #0072ff;
  color: white;
  cursor: pointer;
  transition: all .3s;
  border-radius: 5px;
  white-space: nowrap;
  width: auto;
  min-width: 100px;
}

button:hover {
  opacity: .5;
}


input {
  padding: 10px;
  border-radius: 5px;
  border: 1px solid gray;
  max-height: 40px;
  transition: all .3s;
}

input:hover {
  border: 1px solid #0072ff;
}


.form-group input[type="checkbox"] {
  width: 100%;
  height: 35px;
}

.mainTabs {
  margin-top: 20px;
}

.active-tab {
  background: #0072ff;
  color: white;
}

.mainTabsElem {
  padding: 10px;
  box-shadow: 0px 0px 9px -4px #0072ff;
  border-radius: 5px;
  transition: all .3s;
  cursor: pointer;
}

.mainTabsElem:hover {
  opacity: .5;
}

h3 {
  display: flex;
  gap: 10px;
  flex-direction: row;
  align-items: center;
}

h3 svg {
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
}

.help {
  border: 1px solid #d7d7d7;
  padding: 10px;
  background-color: #e2e2e2;
  border-radius: 5px;
  color: black;
}

.required {
  color: red;
}
</style>
